import { ApiConfig } from './gen/http-client'
import { Auth } from './gen/Auth'
import { Employees } from './gen/Employees'
import { Projects } from './gen/Projects'
import { TestCases } from './gen/TestCases'
import { Config } from '@/app/config'
import { TestRuns } from './gen/TestRuns'

// import Cookies from 'js-cookie'

const customFetch = (
	input: string | URL | Request,
	init?: RequestInit
): Promise<Response> => {
	return fetch(input, {
		...init,
		credentials: 'include',
	});
};

const apiStore = (apiConfig?: ApiConfig<unknown>) => ({
    projects: new Projects(apiConfig),
    employees: new Employees(apiConfig),
    auth: new Auth(apiConfig),
    test_cases: new TestCases(apiConfig),
    test_runs: new TestRuns(apiConfig)
})

const api = apiStore({
	baseUrl: Config.HOST_URL,
	customFetch,
})

export default api;